import BaseMultiSelect from './BaseMultiSelect.vue';
import BaseSelect from './BaseSelect.vue';
import BaseTimePicker from './DateTime/BaseTimePicker.vue';
import BaseDateTimePicker from './DateTime/BaseDateTimePicker.vue';
import BaseDatePicker from './DateTime/BaseDatePicker.vue';

export default [
  BaseMultiSelect,
  BaseSelect,
  BaseTimePicker,
  BaseDateTimePicker,
  BaseDatePicker
];
